import axios from "./axiosinstance";

const ChatMediaApi = {
  upload: (formData) =>
    axios.post("chatMedias/chat", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
};

export default ChatMediaApi;